import { useState } from "react";
import { inputCls } from "@/components/Modal";

// A number field that lets you clear and retype freely: it holds the raw text
// while focused and normalises to a clean number only on blur. Focusing selects
// the contents so you can overtype. Emits a Number via onChange.
export default function NumberInput({
  value,
  onChange,
  min,
  max,
  step = "1",
  emptyValue = 0,
  className = "",
  ...props
}) {
  const [focused, setFocused] = useState(false);
  const [draft, setDraft] = useState("");

  const atRest = value === "" || value === null || value === undefined ? "" : String(value);
  const display = focused ? draft : atRest;

  return (
    <input
      {...props}
      type="number"
      step={step}
      min={min}
      max={max}
      value={display}
      className={`${inputCls} ${className}`}
      onFocus={(e) => {
        const n = parseFloat(value);
        // clear a lone zero so typing replaces it; otherwise select for overtype
        setDraft(!value || n === 0 ? "" : String(value));
        setFocused(true);
        requestAnimationFrame(() => { try { e.target.select(); } catch {} });
      }}
      onChange={(e) => {
        const v = e.target.value;
        setDraft(v);
        const n = parseFloat(v);
        onChange(isNaN(n) ? emptyValue : n);
      }}
      onBlur={() => {
        setFocused(false);
        let n = parseFloat(draft);
        if (isNaN(n)) n = emptyValue;
        if (min != null && n < Number(min)) n = Number(min);
        if (max != null && n > Number(max)) n = Number(max);
        onChange(n);
      }}
    />
  );
}
